import { RobotoTypography } from "@/shared/components/RobotoTypography";
import { SystemUserOnly } from "@/shared/components/SystemUserOnly";
import { SystemUserViewToggle } from "@/shared/components/SystemUserViewToggle";

import { DateTimeFormatPreferences } from "./DateTimeFormatPreferences";
import { NotificationPreferences } from "./NotificationPreferences";
import styles from "./Preferences.module.css";

export function Preferences() {
  return (
    <div className={styles.container}>
      <NotificationPreferences />
      <DateTimeFormatPreferences />
      <SystemUserOnly enforceOverride={false}>
        <div>
          <RobotoTypography variant={"body1"} sx={{ marginBottom: "0.5rem" }}>
            System user controls
          </RobotoTypography>
          <SystemUserViewToggle />
        </div>
      </SystemUserOnly>
    </div>
  );
}
